import { PricingPlanProp } from "../../constants/props";
import styles from "../../constants/styles";
import CheckedList from "./CheckedList";

const PricingPlanTile = ({ planName, price, features }: PricingPlanProp) => {
  return (
    <div
      key={planName}
      className="flex flex-col items-left p-9 rounded-xl bg-gray-100 h-fit"
    >
      <div className="flex flex-col space-y-4 items-start">
        <div className="text-left">
          <h2 className={styles.tertiaryHeading}>{planName}</h2>
          <span className={styles.standardText}>{price}</span>
        </div>

        {features.map(feature => {
          return (
            <div key={feature.featureHeading}>
              <span className={styles.standardTextBold}>
                {feature.featureHeading}
              </span>
              <CheckedList values={feature.featureValues} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PricingPlanTile;
